export const info = (...params) => {global.Rollbar ? global.Rollbar.info(...params): console.info(...params)};
export const error = (...params) => {global.Rollbar ? global.Rollbar.error(...params): console.error(...params)};
export const warn = (...params) => {global.Rollbar ? global.Rollbar.warn(...params): console.error(...params)};

export default {
  info, error, warn
};
